
import { NavItem } from "@school/a2z-lib";
import { environment } from '../../../environments/environment';


export const PrimaryMenuItems: NavItem[] = [

  {
    title: 'Teleconsult',
    subtitle: 'Update & Join Video Consult',
    status: '',
    icon: './assets/media/svg/icons/a2z/video-conference.svg',
    urlLink: '/'+environment.apiVersion+'/teleconsult',
  },
  {
    title: 'Availability',
    subtitle: 'Update Availability Details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/schedule.svg',
    urlLink: '/'+environment.apiVersion+'/availability',
  },
  {
    title: 'Provider',
    subtitle: 'Manage Provider Details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/doctor.svg',
    urlLink: '/'+environment.apiVersion+'/provider',
  },
  {
    title: 'Patient',
    subtitle: 'Manage Patient Details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/doctor.svg',
    urlLink: '/'+environment.apiVersion+'/patient',
  },
  {
    title: 'Account',
    subtitle: 'Profile, User details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/verified-account.svg',
    urlLink: '/'+environment.apiVersion+'/myprofile',
  },
  {
    title: 'Settings',
    subtitle: 'Password, 2FA & Preference',
    status: '',
    icon: './assets/media/svg/icons/a2z/shield.svg',
    urlLink: '/'+environment.apiVersion+'/settings',
  },
];

export const MenuItems: NavItem[] = [

  // {
  //   title: 'Dashboard',
  //   subtitle: 'Practice forms',
  //   status: '',
  //   icon: './assets/media/svg/icons/a2z/video-conference.svg',
  //   urlLink: '/'+environment.apiVersion+'/admin',
  // },
  // {
  //   title: 'Availability',
  //   subtitle: 'Update Availability Details and more',
  //   status: '',
  //   icon: './assets/media/svg/icons/a2z/schedule.svg',
  //   urlLink: '/'+environment.apiVersion+'/availability',
  // },
  // {
  //   title: 'Patient',
  //   subtitle: 'Manage Patient Details and more',
  //   status: '',
  //   icon: './assets/media/svg/icons/a2z/doctor.svg',
  //   urlLink: '/'+environment.apiVersion+'/patient',
  // },
  // {
  //   title: 'Provider',
  //   subtitle: 'Manage Provider Details and more',
  //   status: '',
  //   icon: './assets/media/svg/icons/a2z/doctor.svg',
  //   urlLink: '/'+environment.apiVersion+'/provider',
  // },
  {
    title: 'Account',
    subtitle: 'Profile, User details and more',
    status: '',
    icon: './assets/media/svg/icons/a2z/verified-account.svg',
    urlLink: '/'+environment.apiVersion+'/myprofile',
  },
  {
    title: 'Settings',
    subtitle: 'Password, 2FA & Preference',
    status: '',
    icon: './assets/media/svg/icons/a2z/shield.svg',
    urlLink: '/'+environment.apiVersion+'/settings',
  }
];
